export default __webpack_public_path__ + "static/design-98841254b06a4acb63a0ce3bc4d0d62b.png";